module.exports = __webpack_public_path__ + "img/scale.94c42ddb.svg";